import icon from './icon.svg';
import name from './name.svg';

const svg = {
  icon,
  name,
};

export default svg;
